import type { JSX } from 'react';

import { Image, Text } from '@change/ds-core-ui/next';

export function Instructions(): JSX.Element {
	return (
		<div className="flex flex-col gap-4">
			<Text size="large" fontWeight="bold" variant="body">
				Next steps
			</Text>
			<ul className="flex flex-col gap-4">
				<li key="instruction-1" className="flex flex-row items-center gap-4">
					<Image
						src="https://static.change.org/images/pre-made-post-modal-instructions-1.svg"
						alt="Step 1"
						className="h-[80px] w-[81px] bg-transparent"
					/>
					<Text variant="body" fontWeight="bold">
						Step 1: <br />
						Your message is copied
					</Text>
				</li>
				<li key="instruction-2" className="flex flex-row items-center gap-4">
					<Image
						src="https://static.change.org/images/pre-made-post-modal-instructions-2.svg"
						alt="Step 2"
						className="h-[80px] w-[81px] bg-transparent"
					/>
					<Text variant="body" fontWeight="bold">
						Step 2: <br />
						Paste it into your Facebook post
					</Text>
				</li>
			</ul>
		</div>
	);
}
